// extracted by mini-css-extract-plugin
module.exports = {"fieldWrapper":"Insufficient_fieldWrapper__k3mGv","imgdiv":"Insufficient_imgdiv__2a9vx","row1":"Insufficient_row1__2gsNH","row2":"Insufficient_row2__1phIG"};